import ReactDOMReal from 'react-dom-real';

// React 19 removed findDOMNode. semantic-ui-react calls it internally via
// @fluentui/react-component-ref, and react-transition-group's Transition falls
// back to it when no nodeRef prop is given. Rolldown (Vite 8) bundles react-dom
// as separate copies across chunks, so a runtime mutation of one copy doesn't
// reach the others — this alias makes every chunk resolve 'react-dom' to this
// shim instead, so the fix is baked into each copy at build time.
function findDOMNode(instance: unknown): Element | null {
  if (instance == null) {
    return null;
  }

  if (instance instanceof Element) {
    return instance;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fiber = (instance as any)._reactInternals ?? (instance as any)._reactInternalFiber;
  if (fiber == null) {
    return null;
  }

  let node = fiber;
  while (node) {
    if (node.stateNode instanceof Element) {
      return node.stateNode;
    }
    node = node.child;
  }
  return null;
}

const patchedReactDOM = { ...ReactDOMReal, findDOMNode };

// default export (against the project's named-exports convention) required to satisfy
// existing `import ReactDOM from 'react-dom'` call sites, e.g. FormView.tsx
export default patchedReactDOM;

// `export * from 'react-dom-real'` doesn't survive Rolldown's CJS interop, so re-export react-dom's real API by name instead.
// react-dom/client also self-imports 'react-dom' (hitting this same alias) to grab the internals symbol below and wire up its dispatcher.
export const {
  createPortal,
  flushSync,
  preconnect,
  prefetchDNS,
  preinit,
  preinitModule,
  preload,
  preloadModule,
  requestFormReset,
  unstable_batchedUpdates,
  useFormState,
  useFormStatus,
  version,
  __DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE
} = ReactDOMReal;
export { findDOMNode };
